import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, defineAsyncComponent } from 'vue'
import { DATE_TIME_FORMATS, formatWithLocale } from '@white-label-helper/date-utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'date-range-picker-inputs',
  props: {
    startDateLabel: { default: '' },
    endDateLabel: { default: '' },
    startDate: { default: null },
    endDate: { default: null },
    errors: { default: () => ({
      startDate: '',
      endDate: '',
    }) }
  },
  emits: ['start-date-clicked', 'end-date-clicked'],
  setup(__props: any, { emit }) {

const props = __props as { startDateLabel: string, endDateLabel: string, startDate: Date | null, endDate: Date | null, errors: {
      startDate: string;
      endDate: string;
    } };

const IconCalendar = defineAsyncComponent(() => import('@white-label-icon/icon-calendar'));
const IconError = defineAsyncComponent(() => import('@white-label-icon/icon-error'));

const proxy = getCurrentInstance()?.proxy as Vue;



const computedStartDateLabel = computed(() => props.startDateLabel || proxy.$t('UI.dateRangeInput.label.startDate'));
const computedEndDateLabel = computed(() => props.endDateLabel || proxy.$t('UI.dateRangeInput.label.endDate'));

function formatDate(date: Date): string {
  return formatWithLocale(date, DATE_TIME_FORMATS.weekday_day_month_year, proxy.$i18n.locale)
}



return { __sfc: true,IconCalendar, IconError, proxy, props, computedStartDateLabel, computedEndDateLabel, formatDate, emit }
}

})